// Mappers for employee list operations
import type {
  LC_EmployeeListItemOut,
  LC_GetEmployeesOut,
  Employee,
  EmployeesPage,
  EmployeeListParams,
  LC_GetEmployeesIn,
  EmployeeStatus,
  EmployeeOrderDirection,
} from '../types/employeeList.types';

// Build request body for list
export const buildGetEmployeesIn = (params: EmployeeListParams): LC_GetEmployeesIn => ({
  page: params.page,
  pageSize: params.pageSize,
  searchText: params.searchText ? params.searchText : null,
  orderBy: params.sort?.key ?? null,
  orderDirection: params.sort
    ? params.sort.direction.toUpperCase() as EmployeeOrderDirection
    : null,
  companyIds: params.companyIds.join(','),
  statusFilter: params.statusFilter === 'ALL' ? 'ALL' : params.statusFilter,
  contractStatusFilter: params.contractStatusFilter ?? 'ALL',
});

export const mapEmployeeListItemOutToModel = (dto: LC_EmployeeListItemOut): Employee => {
  const status: EmployeeStatus = dto.status ? 'active' : 'inactive';
  return {
    id: dto.employeeId,
    guid: dto.userId,
    rut: dto.rut || '',
    fullName: dto.fullName || '',
    status,
    companyName: dto.companyName || '',
    contractNumber: dto.contractNumber || '',
  };
};

export const mapPagedEmployees = (out: LC_GetEmployeesOut): EmployeesPage => {
  const data = (out.data || []).map(mapEmployeeListItemOutToModel);
  return {
    data,
    page: out.pagination.currentPage,
    pageSize: out.pagination.pageSize,
    totalRecords: out.pagination.totalRecords,
    totalPages: out.pagination.totalPages,
    orderBy: out.pagination.orderBy || undefined,
    orderDirection: out.pagination.orderDirection ? out.pagination.orderDirection.toLowerCase() as 'asc' | 'desc' : undefined,
    searchText: out.pagination.searchText || undefined,
  };
};

export const mapEnableToStatus = (enable: boolean): EmployeeStatus => (
  enable ? 'active' : 'inactive'
);
